<template>
    <component :is="make(source)"></component>
</template>

<script>
import * as vue from 'vue';
import { Template } from '../library/template'
export default {
    name: "VueMarkdown",
    props:["source"],
    computed: {
        make(){
            return(v) => {
                const page = new Template().render(v)
                return vue.compile(page);
            }
        }
    }

}
</script>
